/* Digital Turn — ShopElmore performance + cart bridge v6 • 12 Sep 2026 */
(function(){
  'use strict';
  if(window.__DT_COMMERCE_UX_V6__) return;
  window.__DT_COMMERCE_UX_V6__=true;

  var LCP_KEY='Elmore-Body-Lotion-Female-Posing-Happy-Smiling-Lifestyle_6364bcc6';

  function isHeroLcpImage(img){
    if(!img) return false;
    return String(img.currentSrc||img.src||img.getAttribute('src')||img.getAttribute('srcset')||'').indexOf(LCP_KEY)!==-1 ||
      String(img.getAttribute('srcset')||'').indexOf(LCP_KEY)!==-1;
  }

  function promoteHeroLcpImage(){
    var imgs=document.querySelectorAll('#MainContent img');
    for(var i=0;i<imgs.length;i++){
      var img=imgs[i];
      if(!isHeroLcpImage(img)) continue;
      img.loading='eager';
      if('fetchPriority' in img) img.fetchPriority='high';
      if(!img.hasAttribute('decoding')) img.decoding='async';
      img.setAttribute('data-dt-lcp-priority','1');
    }
  }

  function neutralizeInvalidVideoSources(){
    document.querySelectorAll('#MainContent video').forEach(function(video){
      var bad=false;
      var refs=[video.getAttribute('src'),video.getAttribute('data-src')];
      video.querySelectorAll('source').forEach(function(source){
        refs.push(source.getAttribute('src'),source.getAttribute('data-src'));
      });
      refs.forEach(function(value){
        value=String(value||'');
        if(value.indexOf('shopify://collections/')!==-1 || /\/collections\/[^/?#]+(?:[?#].*)?$/.test(value)) bad=true;
      });
      if(!bad) return;
      try{video.pause();}catch(e){}
      video.removeAttribute('src');
      video.removeAttribute('data-src');
      video.querySelectorAll('source').forEach(function(source){
        source.removeAttribute('src');
        source.removeAttribute('data-src');
      });
      video.setAttribute('data-dt-invalid-video-source','1');
      try{video.load();}catch(e){}
    });
  }

  /* Cache only known high-frequency storefront reads. */
  (function reduceLegacyPolling(){
    if(window.__DT_REWARDS_FETCH_GUARD__||typeof window.fetch!=='function') return;
    window.__DT_REWARDS_FETCH_GUARD__=true;
    var nativeFetch=window.fetch.bind(window);
    var responseCache=Object.create(null);
    function urlOf(input){return typeof input==='string'?input:((input&&input.url)||'');}
    function methodOf(input,init){return String((init&&init.method)||(input&&input.method)||'GET').toUpperCase();}
    function bust(){delete responseCache.cart;delete responseCache.rewards;}
    window.fetch=function(input,init){
      var url=urlOf(input),method=methodOf(input,init);
      if(method!=='GET'){
        if(/\/cart(?:\.|\/|\?|$)/.test(url)||/\/apps\/elmore-rewards(?:\?|$)/.test(url)) bust();
        return nativeFetch(input,init);
      }
      var key=null,ttl=0;
      if(/\/cart\.js(?:\?|$)/.test(url)&&init&&init.cache==='no-store'){key='cart';ttl=60000;}
      else if(/\/apps\/elmore-rewards(?:\?|$)/.test(url)){key='rewards';ttl=180000;}
      if(!key) return nativeFetch(input,init);
      var now=Date.now(),cached=responseCache[key];
      if(cached&&cached.response&&now-cached.time<ttl) return Promise.resolve(cached.response.clone());
      if(cached&&cached.promise) return cached.promise.then(function(res){return res.clone();});
      var pending=nativeFetch(input,init).then(function(res){
        if(res&&res.ok){var stored=res.clone();responseCache[key]={time:Date.now(),response:stored,promise:null};return stored;}
        delete responseCache[key];return res;
      }).catch(function(err){delete responseCache[key];throw err;});
      responseCache[key]={time:0,response:null,promise:pending};
      return pending.then(function(res){return res&&res.clone?res.clone():res;});
    };
    ['theme:cart:add','cart:updated','theme:cart:updated','theme:cart:change','cart:refresh'].forEach(function(name){document.addEventListener(name,bust,true);});
  })();

  /* Let Broadcast own the drawer; bridge only bespoke ShopElmore ATC forms. */
  var selector=[
    'form.elmore-card__quickform[data-atc-form]',
    'form.adatform[data-adt-atc-form]',
    'form.msb-card__atc',
    'form.dt-grid-form[data-dt-atc-form]',
    'form.dt-elmore-hair__form[data-product-form]',
    'form.dt-elmore-hair__bestForm',
    'form[data-mform]',
    'form.sunForm[data-sun-form]'
  ].join(',');
  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!(form instanceof HTMLFormElement)||!form.matches(selector)) return;
    if(form.dataset.dtCartBusy==='1'){event.preventDefault();return;}
    var button=form.querySelector('button[type="submit"],input[type="submit"]');
    if(!button) return;
    event.preventDefault();event.stopImmediatePropagation();
    document.dispatchEvent(new CustomEvent('theme:cart:add',{detail:{button:button},bubbles:false,cancelable:true}));
  },true);

  /* Keep autoplay media from consuming CPU/GPU while outside the real viewport. */
  function optimizeAutoplayMedia(){
    var videos=Array.prototype.slice.call(document.querySelectorAll('#MainContent video'));
    if(!videos.length) return;
    var io='IntersectionObserver' in window?new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var v=entry.target;
        if(v.dataset.dtWasAutoplay!=='1') return;
        if(entry.isIntersecting){
          v.autoplay=true;
          var p=v.play();if(p&&typeof p.catch==='function') p.catch(function(){});
        }else{
          try{v.pause();}catch(e){}
          v.autoplay=false;
        }
      });
    },{rootMargin:'0px',threshold:0.01}):null;

    videos.forEach(function(v){
      if(v.closest('.drawer--cart')) return;
      var wasAutoplay=v.autoplay||v.hasAttribute('autoplay');
      if(wasAutoplay) v.dataset.dtWasAutoplay='1';
      if(!v.getAttribute('preload')) v.preload='metadata';
      if(io&&wasAutoplay) io.observe(v);
    });

    document.addEventListener('visibilitychange',function(){
      if(!document.hidden) return;
      videos.forEach(function(v){if(v.dataset.dtWasAutoplay==='1'){try{v.pause();}catch(e){}}});
    },{passive:true});
  }

  /* Custom homepage video sections activate themselves before entering the viewport.
     Once they start, pause them outside the viewport and resume only when actually visible. */
  function containCustomHomepageVideos(){
    if(!('IntersectionObserver' in window)) return;
    var selector='.dt-nearby-video,[data-asad-dt-video]';
    var videos=Array.prototype.slice.call(document.querySelectorAll(selector));
    if(!videos.length) return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var v=entry.target;
        v.dataset.dtInViewport=entry.isIntersecting?'1':'0';
        if(entry.isIntersecting){
          if(v.dataset.dtAutoplaySeen==='1'){
            var p=v.play();if(p&&typeof p.catch==='function') p.catch(function(){});
          }
        }else{
          if(!v.paused){try{v.pause();}catch(e){}}
        }
      });
    },{rootMargin:'0px',threshold:0.05});
    videos.forEach(function(v){io.observe(v);});
    document.addEventListener('play',function(e){
      var v=e.target;
      if(!v||!v.matches||!v.matches(selector)) return;
      v.dataset.dtAutoplaySeen='1';
      if(v.dataset.dtInViewport==='0'){
        setTimeout(function(){if(v.dataset.dtInViewport==='0'&&!v.paused){try{v.pause();}catch(err){}}},0);
      }
    },true);
  }

  /* Touch only images the Liquid/theme already marked lazy; never demote the known LCP image. */
  function tuneKnownLazyImages(){
    document.querySelectorAll('#MainContent img[loading="lazy"]').forEach(function(img){
      if(isHeroLcpImage(img)){
        img.loading='eager';
        if('fetchPriority' in img) img.fetchPriority='high';
        img.setAttribute('data-dt-lcp-priority','1');
        return;
      }
      if('fetchPriority' in img&&(!img.fetchPriority||img.fetchPriority==='auto')) img.fetchPriority='low';
      if(!img.hasAttribute('decoding')) img.decoding='async';
    });
  }

  function runNonCriticalPass(){
    promoteHeroLcpImage();
    neutralizeInvalidVideoSources();
    optimizeAutoplayMedia();
    containCustomHomepageVideos();
    tuneKnownLazyImages();
  }
  function schedulePass(){
    /* Priority fixes must happen as soon as DOM exists; heavier scanning may then idle. */
    promoteHeroLcpImage();
    neutralizeInvalidVideoSources();
    if('requestIdleCallback' in window) requestIdleCallback(runNonCriticalPass,{timeout:900});
    else setTimeout(runNonCriticalPass,120);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',schedulePass,{once:true});
  else schedulePass();
})();
